// core components
import Navbar from "../components/Navbars/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import FooterComponent from "../components/Footer/Footer";
import "../assets/css/layouts/admin.css";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";
import { useEffect } from "react";
import InactivityMessage from "../views/Auth/inactivityMessage";

export default function Admin() {
  const authentication = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authentication) {
      navigate("/login");
    }
  }, [authentication]);

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className="main">
        <Outlet />
        <InactivityMessage />
      </div>
      <FooterComponent />
    </div>
  );
}
